@if (show) {
  <div class="form-group">
    <div class="row">
      <div class="col-6">
        <label for="input">
          <span [innerText]="label | translate"></span>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          @if (isLoadingItems) {
            <span class="fa-solid fa-spinner fa-spin ml-2"></span>
          }
        </label>
      </div>
    </div>
    <div class="form-group">
      <ng-select [clearable]="false"
        [(ngModel)]="value"
        (ngModelChange)="onChange($event)"
        [items]="items"
        [disabled]="disabled"
        [hideSelected]="true"
        [dropdownPosition]="last ? 'top' : 'bottom'"
        [placeholder]="placeholder | translate"
        [searchable]="false"
        [ngClass]="{'is-invalid': !isValid}"
        [bindLabel]="bindLabel"
        [bindValue]="bindValue"
        id="input">
        @if (translateItems; as item) {
          <ng-template let-item="item" ng-label-tmp>
            <span [innerHTML]="item['value']['label']|translate"></span>
          </ng-template>
        }
        @if (translateItems; as item) {
          <ng-template let-item="item" ng-option-tmp>
            <span class="d-block" [innerText]="item['value']['label']|translate"></span>
          </ng-template>
        }
      </ng-select>
      @if (control.errors) {
        <div class="invalid-feedback">
          @if (control.errors.required) {
            <span [innerHTML]="errorRequiredMessage|translate"></span>
          }
          @if (control.errors.duplicatedColumns) {
            <span
            translate>This type of column does already exist</span>
          }
        </div>
      }
    </div>
  </div>
}
